module.exports = __webpack_public_path__ + "static/trace-5af594e12a4778c243cc375538c1b824.svg";